<template>
  <div class="pageItem-content" ref="pageItemContent">
    <div class="pageItem"
         :style="{backgroundImage:`url(${pageBg})`,'transform':`scale(${zoom})`,width:width + 'px',height: height + 'px'}">
      <vue-draggable-resizable v-for="(item,index) in page" :draggable="false" :resizable="false" :scaleRatio="zoom"
                               :x="item.infoLeftDr" :y="item.infoTopDr" :w="item.infoWidthDr"
                               :h="item.infoHeightDr" :key="item.id" :index="index">
        <div class="node-content" :style="{'transform':`rotate(${item.classify.rotationAngle}deg)`}">
          <div class="node-content-type ani"
               v-if="item.type === 'img'" :swiper-animate-effect="item.className.join(' ')"
               :swiper-animate-duration="item.animate.animationDuration  + 's'"
               :swiper-animate-delay="item.animate.animationDelay + 's'"
               :style="{
        'animation-timing-function': item.animate.animationTimingFunction,  // 运行曲线
        'animation-iteration-count': item.animate.animationIterationCount, // 播放次数
          }">
            <img :src="item.url" alt="" draggable="false">
          </div>

          <div class="node-content-type ani"
               v-else-if="item.type === 'text'"
               :swiper-animate-effect="item.className.join(' ')"
               :swiper-animate-duration="item.animate.animationDuration  + 's'"
               :swiper-animate-delay="item.animate.animationDelay + 's'"
               :style="{
        'animation-timing-function': item.animate.animationTimingFunction,  // 运行曲线
        'animation-iteration-count': item.animate.animationIterationCount, // 播放次数
         'height':'100%',
        'text-shadow':`${item.classify.fontShadowColor} 0px 0px ${item.classify.fontShadow}px`,
        'box-shadow':`${item.classify.shadowColor} 0px 0px ${item.classify.shadow}px`,
        'color':`${item.classify.fontColor}`,
        'font-size':`${item.classify.fontSize}px`,
          }">

            {{item.content}}
          </div>
        </div>
      </vue-draggable-resizable>
    </div>
  </div>

</template>

<script>
import {mapState} from "vuex"

import VueDraggableResizable from 'vue-draggable-resizable-gorkys'

export default {
  name: "node",
  props: {
    page: {
      type: Array
    },
    pageBg: {
      type: String
    },
  },
  components: {VueDraggableResizable},
  data() {
    return {
      n: true,
      zoom: 1
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const width = this.$refs.pageItemContent.clientWidth
        const height = this.$refs.pageItemContent.clientHeight
        if (this.width / this.height < width / height) {
          this.zoom = height / this.height
        } else {
          this.zoom = width / this.width
        }



      }, 200)
    })
  },
  methods: {},
  computed: {
    ...mapState({
      isActive: state => state.isActive,
      width: state => state.width,
      height: state => state.height,
    }),
  },
}
</script>

<style lang="scss">
@import "~vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css";

.pageItem-content {
  width: 100%;
  height: 100%;
  background: white;
  .pageItem {
    background-size: 100% 100%;
    transform-origin: 0 0;

    .active {
      border: 1px solid transparent;
    }
    .vdr{
      border: none !important;
    }
    .node-content {
      width: 100%;
      height: 100%;

      .node-content-type {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
